<template>
  <Stack class="new-ai-job">
    <Title>Create a new AI Job</Title>
    <JobForm
      :form="form"
      :loading="isSubmitting"
      @submit="handleSubmit"
    />
  </Stack>
</template>

<script setup>
import { defineEmits, ref, watch } from 'vue';
import { ToastProgrammatic as Toast } from 'buefy';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';
import { useJobsStore } from '@frontend/ui/stores/jobsStore';
import JobForm from '../components/JobForm.vue';
import { createEmptyJobForm } from '../cronUtils';
import { Stack, Title } from '@stakeui';

const advisorStore = useAdvisorStore();
const jobsStore = useJobsStore();

const form = ref(createEmptyJobForm());

const isSubmitting = ref(false);

const emit = defineEmits(['done']);

const handleSubmit = async ({ title, prompt, cron, recipients }) => {
  isSubmitting.value = true;

  try {
    await jobsStore.createJob(title, prompt, cron, recipients);

    Toast.open({
      message: `Job successfully created.`,
      type: 'is-success',
    });

    Object.assign(form.value, createEmptyJobForm());

    emit('done');
  } catch {
    Toast.open({
      message: `There was an error creating the job.`,
      type: 'is-danger',
    });
  } finally {
    isSubmitting.value = false;
  }
};

watch(
    () => advisorStore.advisor?.email,
    email => {
      if (email) {
        form.value.recipients = [email];
      }
    },
    { immediate: true },
);
</script>

<style scoped>
.new-ai-job {
  width: 40em;
  padding: 1.5em;
}
</style>
